<template>
  <div class="home">
    <navbar :is-active="4"></navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="nav-mob-resp">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>{{company_name}}</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/Client/ic-operativo-contable" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-briefcase"></i>
            </div>
            <div class="tab__text">
              <p>Operativo - contable</p>
            </div>
          </router-link>
          <router-link to="" class="tab">
            <div class="tab__icon">
              <i class="fas fa-calculator"></i>
            </div>
            <div class="tab__text">
              <p>Contable</p>
            </div>
          </router-link>
        </div>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Incidencias</h2>
        </div>

        <div class="page__filters">
          <input
            @keyup="search"
            v-model="code"
            type="text"
            placeholder="Código Incidencia"
          />
          <div style="display: flex; flex-direction:column; margin-top: -2rem;">
          <label for="">Fecha de Registro</label>
          <input
            v-model="created_at"
            @change="search"
            type="date"
            placeholder="F. Registro"
          />
          </div>
          <input
            @keyup="search"
            v-model="code_invoice"
            type="text"
            placeholder="Código boleta"
          />
          <input @keyup="search" v-model="user_doc_number" type="text" placeholder="DNI" />
          <input @keyup="search" v-model="user_name" type="text" placeholder="Nombres" />
          <input
            @keyup="search"
            v-model="user_lastname"
            type="text"
            placeholder="Apellidos"
          />
          <p @click="clean_filter()"  class="clean_filter">Limpiar Filtros</p>

        </div>
        <div class="page__buttons">
          <ButtonExport
            :data="incidences_export"
            :columns="columns_export"
            icon="fas fa-download"
            :sheet-name="'Datos Incidencias'"
            :file-name="'Reporte Incidencias'"
          />
        </div>
        <div class="page__table" style="height: 100%; overflow: auto">
          <div class="table-headers">
            <p v-for="{ label } of columns" :key="label">{{ label }}</p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div
              class="data"
              v-bind:key="incidence.id"
              v-for="incidence of incidences"
            >
              <p>{{ codeFormat(incidence.id) }}</p>
              <p>{{ dateFormat(incidence.created_at) }}</p>
              <p>{{ codeFormat(incidence.code_invoice)  == 'NaN' ? '-' : codeFormat(incidence.code_invoice) }}</p>
              <p>{{incidence.dni}}</p>
              <p>{{incidence.name}}</p>
              <p>{{incidence.incidence_description}}</p>
              <p>{{incidence.incidence_status_name}}</p>
              <div class="dropdown" >
               <button class="button" @click="show('id-dropdown-content'+incidence.id)">
                 <i class="fa fa-ellipsis" style="color: red"></i>
               </button>
               <div @mouseleave="show('id-dropdown-content'+incidence.id)" class="dropdown-content" :id="'id-dropdown-content'+incidence.id">
                <router-link :to="{ path: '/ShowOperativoContable', query: { id: incidence.id}}" class="dropdown-item">
                  <i class="far fa-eye " ></i> Ver Detalle
                </router-link>
               </div>
              </div>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Navbar from '@/components/NavBar'
  import { dateFormat } from '@/utils/formats'
  import { codeFormat } from '@/utils/formats'
  import ButtonExport from '@/components/ButtonExport.vue'
  import Dropdown from '@/components/Dropdown.vue'
  import Pagination from '@/components/Pagination.vue'
  import OpenArrow from '@/components/OpenArrow.vue'
  import HiddenArrow from '@/components/HiddenArrow.vue'
  import $ from 'jquery'

  export default {
    name: 'OperativoContable',
    components: {
      Navbar,
      ButtonExport,
      Dropdown,
      Pagination,
      OpenArrow,
      HiddenArrow
    },
    data() {
      return {
        type: 'Operativo',
        branch_code: '',
        branch_nickname: '',
        txt_pais: 'Peru',
        branch_pro_id: '',
        branch_dis_id: '',
        branch_status: 0,
        user_doc_number: '',
        user_name: '',
        code: '',
        user_lastname:'',
        code_invoice: '',
        created_at: '',
        empty: false,
        pagination: [],
        incidences_export: [],
        columns: [
          {
            label: 'Código de incidencia',
            field: '',
            dataFormat: value => value || '7896524'
          },
          {
            label: 'Fecha de registro',
            field: 'created_at',
            dataFormat: this.dateFormat
          },
          {
            label: 'Código de boleta',
            field: 'id',
          
          },
          { 
            label: 'DNI', 
            field: 'dni', 
          },
          {
            label: 'Nombres',
            field: 'name',
          },
          {
            label: 'Tipo de Incidencia',
            field: 'incidence_description'
          },
          {
            label: 'Estado',
            field: 'incidence_status_name'
          }
        ],
        columns_export: [
          {
            label: 'Código de incidencia',
            field: 'id',
          },
          {
            label: 'Fecha de registro',
            field: 'created_at',
          },
          {
            label: 'Código de boleta',
            field: 'code',
          },
          { 
            label: 'DNI', 
            field: 'dni',
          },
          {
            label: 'Incidencia Comentario',
            field: 'incidence_comment',
          },
          {
            label: 'Incidencia Resolución',
            field: 'incidence_resolution',
          },
          {
            label: 'Nombres',
            field: 'name',
          },
          {
            label: 'Apellidos',
            field: 'last_name',
          },
          {
            label: 'Número',
            field: 'cellphone',
          },
          {
            label: 'Estado',
            field: 'incidence_status_name'
          }
        ],
        fecha: '',
        usuario: '',
        list: []
      }
    },
    methods: {
       show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
      },
      handleClickInParent: function(page) {
        this.getall(page)
      },
      clean_filter(){
        this.branch_code = ''
        this.branch_nickname = ''
        this.code = ''
        this.created_at = ''
        this.code_invoice= ''
        this.user_doc_number= ''
        this.user_name= ''
        this.user_lastname= ''
        this.getall()
      },
      search: function() {
        clearTimeout(this.timeout);
        var self = this;
        console.log(self);
        this.timeout = setTimeout(function () {
          console.log(self)
          let paramSearch = {
            code: self.code,
            user_doc_number: self.user_doc_number,
            user_name: self.user_name,
            user_lastname: self.user_lastname,
            code_invoice: self.code_invoice,
            created_at: self.created_at,
          }
          this.getall(1, paramSearch)
        }.bind(this), 500);
      },
      dateFormat,
      codeFormat,
      handleClick() {
        localStorage.removeItem('token')
        this.$router.push('/login')
      },
      async getall(page = 1, paramSearch = {}) {
        await axios.get('general/incidence', {params:{
          page: page,
          incidence_company_id: localStorage.getItem('company_id'),
          id: (paramSearch.code) ? paramSearch.code : null,
          user_doc_number:(paramSearch.user_doc_number) ? paramSearch.user_doc_number : null,
          user_name: (paramSearch.user_name) ? paramSearch.user_name : null,
          user_lastname: (paramSearch.user_lastname) ? paramSearch.user_lastname : null,
          code_invoice:  ( typeof paramSearch.code_invoice === 'undefined' || paramSearch.code_invoice === '' ) ? null : parseInt(paramSearch.code_invoice),
          fecha: (paramSearch.created_at) ? paramSearch.created_at : null,
        }}).then( res => {
          if(res.data.data.total > 0){
            this.incidences = res.data.data.data
            this.pagination = res.data.data
            this.incidences_export = res.data.export
            console.log(res.data.data);
            this.empty = false
          }else{
            this.incidences = {}
            this.pagination = {}
            this.empty = true
          }
        })
      },
      AddSucursal() {
        this.$router.push('/Client/AddBranchOffice')
      },
      showBranchOffice(id) {
        this.$router.push({
          path: '/Client/ShowBranchOffice',
          query: { id: id }
        })
      },
      deleteBranchOffice(branch_id) {
        this.$swal({
          title: '¿Estas seguro de eliminar el sucursal?',
          text: '',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar'
        }).then(result => {
          if (result.isConfirmed) {
            let result = axios
              .delete('general/branchoffice/' + branch_id)
              .then(res => {
                console.log(res)
                if (res.data.success) {
                  this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Se elimino correctamente',
                    showConfirmButton: false,
                    timer: 2000
                  })
                  this.$router.go(0)
                } else {
                  this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Ocurrio un problema',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
              })
          }
        })
      },
      searchBranchOffice() {
        console.log('ingreso')
        // this.branchoffice = []
      },
      basicInfo() {
        this.usuario = localStorage.getItem('usuario')
        this.list = JSON.parse(localStorage.getItem('getListOfMenu'))
        this.getDate()
      },
      getDate() {
        let dias = [
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado',
          'Domingo'
        ]
        let meses = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ]

        let date = new Date()

        var fechaNum = date.getDate()
        var mes_name = date.getMonth()

        this.fecha =
          dias[date.getDay() - 1] +
          ' ' +
          this.zeroFill(fechaNum, 2) +
          ' de ' +
          meses[mes_name]
      },
      zeroFill(number, width) {
        width -= number.toString().length
        if (width > 0) {
          return (
            new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
          )
        }
        return number + ''
      },
      url(path) {
        this.$router.push(path)
      }
    },
    mounted() {
      this.basicInfo()
      if (localStorage.getItem('token')) {
        this.getall()
        this.company_name = localStorage.getItem('company_name');
      } else {
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>
  /*------NAVBAR------*/
  .home .navbar {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
  }

  .home .navbar__left {
    width: 200px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .home .navbar__left img {
    width: 130px;
  }

  .home .navbar__center {
    width: 70%;
    height: 100%;
  }

  .home .navbar__center ul {
    width: 100%;
    height: 100%;
    display: flex;
    list-style: none;
    display: flex;
    justify-content: flex-start;
  }
  .home .navbar__center ul li {
    text-decoration: none;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
  }

  .home .navbar__center ul li.active {
    color: #ff3128;
  }
  .home .navbar__center ul li.active::before {
    width: 100%;
  }

  .home .navbar__center ul li::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 0;
    height: 4px;
    background-color: #ff3128;
    transition: 0.3s ease;
  }
  .home .navbar__center ul li:hover {
    color: #ff3128;
  }
  .home .navbar__center ul li:hover::before {
    width: 100%;
  }

  .home .navbar__right {
    display: flex;
  }
  .home .navbar__right .profile {
    display: flex;
    width: 300px;
    height: 100%;
  }

  .home .navbar__right .profile__detail {
    width: 220px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 5px;
  }
  .home .navbar__right .profile__detail p {
    margin: 0;
  }
  .home .navbar__right .profile__detail span {
    color: #938f8f;
    font-weight: 300;
  }

  .home .navbar__right .profile__icon,
  .home .navbar__right .profile__logout {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    color: #ff3128;
    cursor: pointer;
  }
  /*------NAVBAR------*/

  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }
  /*-------------------------*/
  /*-------------------------*/

  /*------BODY------*/

  .body {
    width: 100%;
    height: 600px;
    display: flex;
  }
  .body__containt {
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }
  .body__sidebar {
    width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .body__sidebar .floating-icon {
    position: absolute;
    right: -15px;
    top: 30px;
    color: #ff3128;
    font-size: 30px;
  }

  .body__sidebar .title {
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
  }

  .body__sidebar .title__text h2 {
    font-size: 20px;
    margin: 0;
  }
  .body__sidebar .title__text p {
    margin: 0;
    font-weight: 300;
  }

  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 140px);
    padding-top: 5px;
  }

  .body__sidebar .tabs .tab {
    width: 90%;
    height: 70px;
    border-radius: 10px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: 0.3 ease;
  }
  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }

  .body__sidebar .tabs .tab__icon {
    font-size: 20px;
    margin-right: 10px;
  }

  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
  }

  .body__containt {
    height: fit-content;
    min-height: 87vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }

  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
  }

  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
  }

  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
  }
  .body__containt .page__filters input,
  select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /*margin: 0 10px;*/
    width: 300px;
  }

  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding-top: 2%;
  }

  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .body__containt .page__buttons .button:nth-child(1) {
    background: #262626;
  }

  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }

  .body__containt .page__table .table-headers {
    width: 111%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-headers p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }

  .body__containt .page__table .table-body {
    width: 111%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
  }

  .body__containt .page__table .table-body .data {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .body__containt .page__table .table-body .data p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
  }
  .body__containt .page__table .table-body .data p:nth-child(1) {
    color: #ff3128;
  }
  .body__containt .page__filters input:nth-child(3) {
    width: 300px;
    margin: 0;
    margin-right: 100px;
  }
  .body__sidebar.open{
    display: none;
  }

  /*------BODY------*/
  /* INICIO MOBILE*/
  @media (max-width: 768px){
    .body__containt .page__title h2{
      font-size: 21px;
    }
    .body__containt .page__filters input{
      padding: 5px 20px;
    }
    .page__filters select{
      padding: 10px 19px;
      width: 54% !important;
    }
    .body label{
      margin-top: 2rem;
      margin-left: 18px;
      font-size: 13px;
    }
    .body p.clean_filter{
      margin-top: 7px;
      font-size: 14px;
    }
    .buttonExport{
      margin-top: -13px;
      width: 179px;
      padding: 9px 20px;
    }
    .body__containt .page__table{
      font-size: 11px;
    }
    .body__containt .page__table .table-headers{
      margin-top: 6px;
      width: 245%;
    }
    .body__containt .page__table .table-body{
      width: 245%;
    }
    .body__containt .page__table .table-body{
      width: 245%;
    }
    .body__sidebar .title__text h2 {
      font-size: 18px;
    }
    .body__sidebar .title__text {
      margin: 0 10px;
      font-size: 16px;
    }
    .body__sidebar .title__icon{
      font-size: 16px;
      margin-left: 6px;
    }
    .body__sidebar .tabs .tab__icon svg{
      font-size: 15px;
      margin-right: 7px;}
    .body__sidebar .tabs .a{
      margin-left: -2px;
      margin-top: -1px;
    }
    .body__sidebar a svg{
      font-size: 22px;
    }
    /*BARRA LATERAL IZQUIERDA MOBILE*/
    .body__sidebar .tabs .tab__icon {
      color: white;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
      color: #ff3128;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
      color: #ff3128;
      font-size: 20px;
    }
    .body__sidebar .tabs .tab__text p {
      margin-left: -8px;
      color: white;
      font-size: 18px;
    }
    .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
      background: #262626;
      margin-bottom: -11px;
    }
    .body__containt .page__buttons .button{
      font-size: 13px;
      padding: 5px 20px;
      margin-top: -18px;
    }
    .body__containt .page__buttons {
      width: 105%;
    }
    .home .body .nav-mob-resp{
      position: absolute;
      background: #262626;
      height: 85vh;
      width: 25vh;
    }
    .body__sidebar .title {
      color: white;
    }
    .body__sidebar .floating-icon {
      position: absolute;
      right: -35px;
    }
    .body__sidebar .tabs .tab{
      margin-bottom: -7px;
    }
  }
</style>
